import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/u/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/u/sdsd"!</div>
}
